// Types of Actions

// Window
export const RESIZE_WINDOW = "RESIZE_WINDOW";
